import {Injectable} from "@angular/core";
import Upsert from 'pouchdb-upsert';
import ResolveConflicts from 'pouch-resolve-conflicts';
import {Observable} from "rxjs/Observable";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import "rxjs/add/operator/map";
import {Events, LoadingController, ModalController} from "ionic-angular";
import {ConflictManagementPage} from "../../pages/conflict-management/conflict-management";
import {GlobalProvider} from "../global/global";
import PouchDB from 'pouchdb';
import cordovaSqlitePlugin from 'pouchdb-adapter-cordova-sqlite';
import {LoginProvider} from "../login/login.provider";
import {Subject} from "rxjs/Subject";
import {ContactService} from "../../store/contact/contact.service";
import {TemplateService} from "../../store/template/template.service";
import {AuditService} from "../../store/audit/audit.service";
import {LocationService} from "../../store/location/location.service";
import {NoteService} from "../../store/note/note.service";
import {RemarkService} from "../../store/remark/remark.service";
import {SettingService} from "../../store/setting/setting.service";
import {ProtocolService} from "../../store/protocol/protocol.service";

/*
  Generated class for the CustomerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {

  private _localDB: PouchDB;
  private _remoteDB: PouchDB;
  private _localPushSyncHandler = null;
  private _localPullSyncHandler = null;
  private _localChangesHandler = null;

  private _syncOptions = {};

  constructor(private modalCtrl: ModalController,
              private events: Events,
              private loadingCtrl: LoadingController,
              private globalProvider: GlobalProvider,
              private loginProvider: LoginProvider,
              private contactService: ContactService,
              private templateService: TemplateService,
              private auditService: AuditService,
              private locationService: LocationService,
              private noteService: NoteService,
              private remarkService: RemarkService,
              private settingService: SettingService,
              private protocolService: ProtocolService) {

    this._initDBPlugins();
    // this.init();

  }

  public init(): Promise<any>{

    return new Promise((resolve, reject) => {

          //logged-in

          this._setSyncOptions();


          if(!this.globalProvider.isBrowser()){
            this._remoteDB = new PouchDB(this.globalProvider.remoteDatabaseURL+this.globalProvider.database.name, {ajax: {withCredentials: true}});

            // this._localDB = new PouchDB(this.globalProvider.database.name, {adapter: 'cordova-sqlite', iosDatabaseLocation: 'default'});
            this._localDB = new PouchDB(this.globalProvider.database.name);



            this.enableInitSyncForLocalDB()
              .then((success) => {
                this._enableLiveSyncForLocalDB();
                this._handleLocalDBChanges();


              }, (error) => {
                console.dir(error);
              });
          }
          else{
            this._localDB = new PouchDB(this.globalProvider.remoteDatabaseURL+this.globalProvider.database.name, {ajax: {withCredentials: true}});


            let loadingMessage = this.loadingCtrl.create({content: 'Daten werden geladen. Bitte warten...'});
            loadingMessage.present();
            this._loadAllDocuments()
              .then(() => {
                loadingMessage.dismissAll();
                resolve();
              }, () => {
                loadingMessage.dismissAll();
                reject();
              })
              .then(() => {
                this._handleLocalDBChangesOnline();
              })

          }



    })
  }

  private _initDBPlugins(): void {
    PouchDB.plugin(Upsert);
    PouchDB.plugin(ResolveConflicts);
    PouchDB.plugin(cordovaSqlitePlugin);
  }

  private _setSyncOptions(): void {
    this._syncOptions = {
      live: true,
      retry: true,
      filter: 'doc_filters/by_user',
      query_params: { "userId": this.globalProvider.user.uuid }
    };
  }

  private _handleLocalDBChanges(): void {
    this._localChangesHandler = this._localDB.changes({
      since: 'now',
      live: true,
      include_docs: true,
      conflicts: true,
      attachments: true
    })
      .on('change', (change) => {
        // handle change
        console.log('localDB Changed');
        console.dir(change);
        if(change.doc._conflicts && change.doc._conflicts.length !== 0 && change.doc.hasOwnProperty('ownerId') && change.doc.ownderId === this.globalProvider.user.uuid){
          this._showConflictModal(change);
        }
        else{
          const action = (change.doc.hasOwnProperty('deleted') && change.doc.deleted) || change.doc.hasOwnProperty('_deleted') ? 'remove' : 'set';
          this._handleDocuments(change.doc, action);
        }
      })
      .on('error', (error) => {
        this._handleDBError(error);
      })
  }

  private _showConflictModal(change: any){
    this.events.publish('conflict:'+change.doc._id);
    this._localDB.get(change.doc._id, {open_revs: [change.doc._conflicts[0]]})
      .then((conflictDocument) => {
        console.dir(conflictDocument);
        let conflictModal = this.modalCtrl.create(ConflictManagementPage, {leftSide: change.doc, rightSide: conflictDocument[0].ok}, {enableBackdropDismiss: false});
        conflictModal.onDidDismiss((data) => {
          if(data !== undefined){
            console.dir(data);
            this.solveConflict(data.id, data.rev);
          }
        });
        conflictModal.present();
      }, error => {
        console.dir(error);
      })
  }

  private _handleLocalDBChangesOnline(): void {
    this._localChangesHandler = this._localDB.changes({
      // since: 'now',
      live: true,
      include_docs: true,
      conflicts: true,
      attachments: false,
      // filter: 'doc_filters/by_user',
      // query_params: { "userId": this.globalProvider.user.uuid }
    })
      .on('change', (change) => {
        const action = (change.doc.hasOwnProperty('deleted') && change.doc.deleted) || change.doc.hasOwnProperty('_deleted') ? 'remove' : 'set';
        this._handleDocuments(change.doc, action);
      })
      .on('error', (error) => {
        this._handleDBError(error);
      });
  }

  private _handleDocuments(doc: any, action: string){
    switch (doc.docType){
      case 'contact':
        this.contactService[action](doc);
        break;
      case 'template':
        this.templateService[action](doc);
        break;
      case 'audit':
        this.auditService[action](doc);
        break;
      case 'location':
        this.locationService[action](doc);
        break;
      case 'note':
        this.noteService[action](doc);
        break;
      case 'remark':
        this.remarkService[action](doc);
        break;
      case 'settings':
        this.settingService[action](doc);
        break;
      case 'protocol':
        this.protocolService[action](doc);
        break;
    }
  }

  public enableInitSyncForLocalDB(): Promise<any> {

    let loadingMessage = this.loadingCtrl.create({content: 'Datenbank wird synchronisiert. Bitte warten...'});
    loadingMessage.present();

    return new Promise((resolve, reject) => {
      PouchDB.sync(this._localDB, this._remoteDB, this._syncOptions)
        .on('change', (info) => {
          console.log('rep change [remoteDB]:');
          console.dir(info);
          if(info.direction === 'pull'){
            //update from remoteDB
            info.change.docs.forEach((doc) => {
              const action = (doc.hasOwnProperty('deleted') && doc.deleted) || doc.hasOwnProperty('_deleted') ? 'remove' : 'set';
              this._handleDocuments(doc, action);
            })
          }
        })
        .on('complete', (info) => {
          loadingMessage.dismiss();
          resolve();
        })
        .on('error', (error) => {
            this._handleDBError(error);

            console.log(error);
            reject(error);
        })
    });
  }


  private _handleDBError(error) {
    //on unauthorized logout
    if(error.status === 403){
      this.stopAllSync();
      // this.loginProvider.setLoggedOut({message: 'Nicht authorisiert'});
      this.loginProvider.setLoggedOut();
      //todo: logout
    }
  }


  private _enableLiveSyncForLocalDB():void {
    console.log('enableLiveSyncForLocalDB');

    this._localPushSyncHandler = PouchDB.replicate(this._localDB, this._remoteDB, {
      live: true,
      retry: true,
    }).on('change', function (info) {
      // handle change
      console.log('rep change [remoteDB]:');
      console.dir(info);
    }).on('paused', function (err) {
      // replication paused (e.g. replication up to date, user went offline)
      console.log('rep paused [remoteDB]:');
      console.dir(err);
    }).on('active', function () {
      // replicate resumed (e.g. new changes replicating, user went back online)
      console.log('rep active [remoteDB]');
    }).on('denied', function (err) {
      // a document failed to replicate (e.g. due to permissions)
      console.log('rep denied [remoteDB]:');
      console.dir(err);
    }).on('complete', function (info) {
      // handle complete
      console.log('rep: complete [remoteDB]:');
      console.dir(info);
    }).on('error', (error) => {
      // handle error
      console.log('rep error [remoteDB]:');
      console.dir(error);
      //on unauthorized logout
      this._handleDBError(error);
      console.log(error);
    });

    this._localPullSyncHandler = PouchDB.replicate(this._remoteDB, this._localDB, this._syncOptions)
      .on('change', (info) => {
        // handle change
        console.log('rep change [remoteDB]:');
        console.dir(info);
      })
      .on('error', (error) => {
        this._handleDBError(error);
      })
  }

  private _loadAllDocuments(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._localDB.allDocs({
        include_docs: true,
        attachments: false,
        conflicts: true
      })
        .then((result) => {
          //filter out the design documents
          for(let row of result.rows){
            if(row.doc && row.doc.hasOwnProperty('docType')){
              const action = (row.doc.hasOwnProperty('deleted') && row.doc.deleted) || row.doc.hasOwnProperty('_deleted') ? 'remove' : 'set';
              this._handleDocuments(row.doc, action);
            }
          }
          resolve(true);
        })
        .catch((err) => {
          //on unauthorized logout
          if(err.status === 401){
            this.stopAllSync();
            // this.loginProvider.setLoggedOut({message: 'Nicht authorisiert'});
            //todo: logout
          }
          console.log(err);
          reject(err);
      });
    });



  }


  public createDocumentWithoutInit(data): Promise<any> {
    data.userId = this.globalProvider.user.uuid;
    data.ownerId = this.globalProvider.user.uuid;
    if(data.readers){
      data.readers = [...data.readers, this.globalProvider.user.uuid];
    }
    else {
      data.readers = [this.globalProvider.user.uuid];
    }

    data.created_by = this.globalProvider.user.firstname + ' ' + this.globalProvider.user.lastname;
    data.created_at = Date.now();
    return new Promise((resolve, reject) => {
      this._localDB.post(data)
        .then((success) => {
          this._localDB.get(success.id)
            .then((doc) => {
              resolve(doc);
            }, (err) => reject(err));
        }, (err) => reject(err));
    })
  }

  public updateDocument(doc): Promise<any>{
    doc.updated_by = this.globalProvider.user.firstname + ' ' + this.globalProvider.user.lastname;
    doc.updated_at = Date.now();
    return new Promise((resolve, reject) => {
      this._localDB.get(doc._id)
        .then((dbDoc) => {
          doc._rev = dbDoc._rev;
          this._localDB.put(doc)
            .then((success) => {
              resolve(doc);
            }, (error) => {
              reject(error);
            })
        }, (error) => {
          reject(error);
        })
    })
  }

  public solveConflict(id, rev): Promise<any> {
    return this._localDB.remove(id, rev);
  }

  public softDeleteDocument(doc): Promise<any>{
    doc.deleted_by = this.globalProvider.user.firstname + ' ' + this.globalProvider.user.lastname;
    doc.deleted = true;
    return this.updateDocument(doc);
  }

  public softDeleteDocumentById(id): Promise<any>{
    return this.getDocmentById(id)
      .then((doc) => {
        return this.softDeleteDocument(doc);
      })
  }

  public getDocmentById(id: string): Promise<any> {
      return this._localDB.get(id)
  }

  public saveAttatchment(docId: string, fileName: string, blob: any, fileType: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._localDB.get(docId)
        .then((dbDoc) => {
          this._localDB.putAttachment(docId, fileName, dbDoc._rev, blob, fileType)
            .then((success) => {
              return this._localDB.get(docId);
            }, (error) => reject(error))
            .then((updatedDocument) => {
              resolve(updatedDocument);
            }, (error) => reject(error));
        }, (error) => {
          reject(error);
        })
    })
  }

  public getAttachment(docId: string, fileName: string): Promise<any> {
    return this._localDB.getAttachment(docId, fileName);
  }

  public removeAttachment(docId: string, fileName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._localDB.get(docId)
        .then((dbDoc) => {
          this._localDB.removeAttachment(docId, fileName, dbDoc._rev)
            .then(() => {
              return this._localDB.get(docId);
            }, (error) => {
              console.log(error);
              reject(error);
            })
            .then((updatedDocument) => {
              resolve(updatedDocument);
            }, (error) => {
              console.log(error);
              reject(error);
            });
        }, (error) => {
          console.log(error);
          reject(error);
        });
    });
  };

  public stopAllSync():void {
    if(this._localPushSyncHandler){
      this._localPushSyncHandler.cancel();
    }

    if(this._localPullSyncHandler){
      this._localPullSyncHandler.cancel();
    }

    if(this._localChangesHandler){
      this._localChangesHandler.cancel();
    }

    this._localDB = null;
    this._remoteDB = null;
  }

  public initLocalDB(): void {
    try{
      this.stopAllSync();
    }catch(e){
      console.dir(e);
    }

    this._localDB = new PouchDB(this.globalProvider.database.name);
  }

}



// WEBPACK FOOTER //
// ./src/providers/dataprovider/dataprovider.ts